import { useCallback } from 'react';
import { usePortletTranslations } from 'js/components/system/Portlet/hooks/usePortletTranslations';
import { T_KEYS_NO_BECAUSE_YOU_PLAYED_GAMES } from '../constants';
import { getIsBecauseYouPlayed } from '../helpers';
import { TTranslationStringifyValue } from 'js/hooks/i18n/types';

type UseCategoryType = { gameName: TTranslationStringifyValue, cid: string, categoryName: string };

export const useCategoryName = () => {
    const t = usePortletTranslations();

    return useCallback(({ gameName, cid, categoryName }: UseCategoryType) => {
        const isBecauseYouPlayed = getIsBecauseYouPlayed(cid);

        return gameName && isBecauseYouPlayed ?
            t(categoryName, (gameName && [gameName]) as TTranslationStringifyValue[]) : !isBecauseYouPlayed ?
                t(categoryName, (gameName && [gameName]) as TTranslationStringifyValue[]) : t(T_KEYS_NO_BECAUSE_YOU_PLAYED_GAMES);
    }, [t]);
};
